<template>
  <v-snackbar
    :timeout="timeout"
    :top="true"
    :right="true"
    :color="snackBar.color"
    :multi-line="snackBar.multiLine"
    v-model="show"
  >
    {{ snackBar.text }}
    <v-btn v-if="snackBar.actionText" flat color="purple" @click.native="clickAction">
      {{ snackBar.actionText }}
    </v-btn>
    <v-btn v-else flat color="primary" @click.native="show = false">
      {{ $t('common.close') }}
    </v-btn>
  </v-snackbar>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    timeout: {
      type: Number,
      default: 3000,
    },
  },

  computed: {
    ...mapState(['snackBar']),

    show: {
      get() {
        return this.$store.state.snackBar.show;
      },

      set(newValue) {
        this.$store.commit('toggleSnackBar', newValue);
      },
    },
  },

  methods: {
    clickAction() {
      if (
        this.snackBar.actionCallback &&
        this.snackBar.actionCallback.constructor &&
        this.snackBar.actionCallback.call &&
        this.snackBar.actionCallback.apply
      )
        this.snackBar.actionCallback();

      this.show = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/layout/SnackBar.vue